export class TipoReporte{

    TipoID: number;
    Nombre: string;

}
